export function initializationFailureCopy(pathname: string): {
  heading: string;
  detail: string;
} {
  if (pathname.split("/").filter(Boolean)[0] === "zh-Hans") {
    return {
      heading: "OpenFusionLab 无法初始化",
      detail: "尚未运行任何计算。请检查静态站点配置后刷新页面。",
    };
  }
  return {
    heading: "OpenFusionLab could not initialize",
    detail: "No calculation has run. Refresh after checking the static-site configuration.",
  };
}
